<agr-dialog
  [data]="data"
  (close)="cancel()"
  (cancel)="stepBack()"
  (alt)="stepForward()"
  (confirm)="addToCart()"
  class="product-wizard-dialog"
  data-test="product-wizard-dialog"
>
  <div class="flex flex__column spacing--margin-vertical">
    <div class="flex__child spacing--margin-right white-space--no-wrap" *ngIf="(isLtSm$ | async) === false">
      <div class="text--small text--gray">
        {{ 'product.product' | translate }}
      </div>
      <div>{{ cartLine.skuTitle }}</div>
    </div>
    <div class="flex__child" *ngIf="(isLtSm$ | async) === false">
      <div class="text--small text--gray">
        {{ 'product.product-code' | translate }}
      </div>
      <div>{{ cartLine.externalSkuId }}</div>
    </div>
    <div class="flex__child">
      <div class="text--small text--gray">
        {{ 'product.minimum-order-unit-quantity' | translate }}
      </div>
      <div>
        {{ cartLine.orderingInformation.minimumOrderUnitQuantity }}
        {{ 'unit.' + cartLine.orderingInformation.orderUnit | translate }}
      </div>
    </div>
    <div class="flex__child">
      <div class="text--small text--gray">
        {{ 'product.increase-order-unit-quantity' | translate }}
      </div>
      <div>
        {{ cartLine.orderingInformation.increaseOrderUnitQuantity }}
        {{ 'unit.' + cartLine.orderingInformation.orderUnit | translate }}
      </div>
    </div>
  </div>
  <mat-divider></mat-divider>

  <div *ngIf="cartLine">
    <p *ngIf="isBlockedForReturn" class="product-wizard-dialog__blocked-for-retun">{{ 'product.wizard.blocked-for-return' | translate }}</p>
    <mat-stepper
      #wizardStepper
      class="product-wizard-dialog__stepper"
      data-test="product-wizard-dialog__stepper"
      (selectionChange)="handleStepperSelectionChange($event)"
      [orientation]="orientation"
    >
      <mat-step [hasError]="quantityIsValid === false" [errorMessage]="'product.wizard.quantity.tab-invalid' | translate">
        <ng-template matStepLabel>{{ 'product.wizard.quantity.title' | translate }}</ng-template>
        <app-product-quantity
          (quantityChange)="handleQuantityChange($event)"
          (quantityIsValid)="handleQuantityIsValidChange($event)"
          [quantityItem]="quantityItem"
        >
        </app-product-quantity>
      </mat-step>
      <mat-step
        *ngIf="silosAreRelevant"
        [hasError]="silosAreValid === false"
        [optional]="silosAreOptional === true"
        [errorMessage]="'product.wizard.silo.tab-invalid' | translate"
      >
        <ng-template matStepLabel>{{ 'product.wizard.silo.title' | translate }}</ng-template>
        <app-product-silo
          [quantity]="cartLine.quantity"
          [selectedSilos]="cartLine.silos ?? []"
          [orderingInformation]="cartLine.orderingInformation"
          (silosChange)="handleSilosChange($event)"
          (silosAreValid)="handleSilosAreValidChange($event)"
          (silosAreOptional)="silosAreOptional = $event"
        >
        </app-product-silo>
      </mat-step>
      <mat-step *ngIf="cartLine.hasProductSupplements === true">
        <ng-template matStepLabel>{{ 'product.wizard.supplement.title' | translate }}</ng-template>
        <app-product-supplement [lineItem]="lineItem" (productSupplementsChange)="handleProductSupplementsChange($event)"> </app-product-supplement>
      </mat-step>
      <mat-step [hasError]="deliveryInformationIsValid === false" [errorMessage]="'product.wizard.delivery-moment.tab-invalid' | translate">
        <ng-template matStepLabel>
          {{ 'product.wizard.delivery-moment.title' | translate }}
        </ng-template>
        <app-product-delivery-moment
          [wizardMode]="data.mode"
          [cartId]="cartId"
          [cartLineId]="cartLine?.id"
          [skuId]="data.skuCatalogItem?.skuId"
          [allowedFlexibility]="data?.skuCatalogItem?.orderingInformation?.flexibility ?? 0"
          [initialFlexibility]="
            data?.cartLine?.deliveryInformation?.flexibility ??
            (data?.skuCatalogItem?.orderingInformation?.useFixedFlexibility === true ? 0 : data?.skuCatalogItem?.orderingInformation?.flexibility)
          "
          [deliveryInformation]="deliveryInformationValue"
          (deliveryInformationIsValid)="handleDeliveryInformationIsValidChange($event)"
          (deliveryInformationChanged)="handleDeliveryInformationChange($event)"
        >
        </app-product-delivery-moment>
      </mat-step>
    </mat-stepper>
  </div>
</agr-dialog>
